import React from "react";
import { useIntl } from "react-intl";
import "./UpcomingDatesIndicator.styl";

const UpcomingDatesIndicator = ({ dates, isLoading }) => {
  const intl = useIntl();

  return (
    <div className="upcoming-dates-indicator">
      {isLoading ? (
        <div className="upcoming-dates-indicator--loading">
          <div className="upcoming-dates-indicator--loading__dot upcoming-dates-indicator--loading__dot--1" />
          <div className="upcoming-dates-indicator--loading__dot upcoming-dates-indicator--loading__dot--2" />
          <div className="upcoming-dates-indicator--loading__dot upcoming-dates-indicator--loading__dot--3" />
          <div className="upcoming-dates-indicator--loading__dot upcoming-dates-indicator--loading__dot--4" />
        </div>
      ) : (
        dates.map((dateInfo, index) => {
          const indicatorClasses = [
            "upcoming-dates-indicator__date-indicator",
            dateInfo.selected &&
              "upcoming-dates-indicator__date-indicator--selected",
            dateInfo.disabled &&
              "upcoming-dates-indicator__date-indicator--disabled",
            dateInfo.sold && "upcoming-dates-indicator__date-indicator--sold",
          ]
            .filter(Boolean)
            .join(" ");

          const tooltip = dateInfo.selected
            ? intl.formatMessage(
                { id: "deliveringOn" },
                { date: dateInfo.date },
              )
            : intl.formatMessage(
                { id: "notDeliveringOn" },
                { date: dateInfo.date },
              );

          return (
            <div
              key={dateInfo.date_iso_formatted || dateInfo.date || index}
              className="upcoming-dates-indicator__date-indicator-wrapper"
            >
              <div className={indicatorClasses} />
              <span className="upcoming-dates-indicator__tooltip">
                {tooltip}
              </span>
            </div>
          );
        })
      )}
    </div>
  );
};

export default UpcomingDatesIndicator;
